import { message } from 'antd';
import { useTranslate } from '@tolgee/react';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { list } from 'services/api/assistant.account';

const isOnlyOneAssistantState = atom(false);
const isOverOneAssistantState = atom(false);

export const useIsOnlyOneAssistant = () => useAtomValue(isOnlyOneAssistantState);
export const useIsOverOneAssistantState = () => useAtomValue(isOverOneAssistantState);

export const useRefreshIsOnlyOneAssistant = () => {
  const { t } = useTranslate();
  const setIsOnlyOneAssistant = useSetAtom(isOnlyOneAssistantState);
  const setIsOverOneAssistant = useSetAtom(isOverOneAssistantState);
  return () => {
    list({ page: 1, pageSize: 10 })
      .then((res) => {
        const accountList = res.data || [];
        const filterAdmin = accountList.filter((item) =>
          item.roles.every((role) => role.name !== 'SUPER_ADMIN'),
        );
        const only = filterAdmin.length <= 1;
        const over = filterAdmin.length >= 1;

        setIsOnlyOneAssistant(only);
        setIsOverOneAssistant(over);
      })
      .catch(() => {
        message.error(t('api.assistantListOnlineStatusStatusErr'));
      });
  };
};
